import { Box, Stack, Typography } from '@mui/material';

import { COPY_GENERATOR_USER_BUBBLE_BG } from '../utils';

// Figma: Text/Default (#1F1F1F) — not present in themeColors; kept as literal.
const USER_TEXT_COLOR = '#1F1F1F';

export type Props = {
    content: string;
};

const UserMessageBubble = ({ content }: Props) => (
    <Stack alignItems="flex-end" direction="row" justifyContent="flex-end" sx={{ width: '72%', pl: 10.5 }}>
        <Box
            sx={{
                position: 'relative',
                maxWidth: '100%',
                px: 2,
                py: 1.5,
                borderRadius: '6px',
                bgcolor: COPY_GENERATOR_USER_BUBBLE_BG,
            }}
        >
            <Typography
                sx={{
                    color: USER_TEXT_COLOR,
                    fontSize: 16,
                    letterSpacing: '0.15px',
                    lineHeight: '24px',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                }}
            >
                {content}
            </Typography>
        </Box>
    </Stack>
);

export default UserMessageBubble;
